import React, { useEffect, useState } from "react";

const ChatLoader = () => {
  const thinkingPhrases = [
    "Analyzing information",
    "Connecting concepts",
    "Synthesizing response",
    "Evaluating context",
    "Processing query",
  ];

  const [currentPhrase, setCurrentPhrase] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhrase((prev) => (prev + 1) % thinkingPhrases.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const mainColor = "#3E68FE";

  return (
    <div style={styles.container}>
      <div style={styles.textWrapper}>
        <span style={{ ...styles.baseText, WebkitTextFillColor: "transparent" }}>{thinkingPhrases[currentPhrase]}</span>
        <span
          style={{
            ...styles.shimmerText,
            backgroundImage: `linear-gradient(90deg, transparent, ${mainColor}, transparent)`,
          }}>
          {thinkingPhrases[currentPhrase]}
        </span>
      </div>

      <style>{keyframes}</style>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    height: "60px",
    width: "100%",
    background: "transparent",
  },
  textWrapper: {
    position: "relative",
    overflow: "hidden",
    background: "transparent",
  },
  baseText: {
    fontSize: "18px",
    fontWeight: 500,
    color: "transparent",
    position: "relative",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
  },
  shimmerText: {
    position: "absolute",
    inset: 0,
    backgroundSize: "200% 100%",
    animation: "shimmer 2s infinite linear",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    color: "transparent",
  },
};

const keyframes = `
  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export default ChatLoader;
